module.exports = __webpack_public_path__ + "img/feedback9-3.ecf812b7.jpg";